export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Comment',
    },
    cell: {
      type: 'text',
      value: (e) => e.comment,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Created At',
    },
    cell: {
      type: 'slot',
      name: 'createDate',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Influence',
    },
    cell: {
      type: 'slot',
      name: 'influence',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Deleted',
    },
    cell: {
      type: 'slot',
      name: 'deleted',
    },
  },
];
